<template>
  <div id="choseOrg">
    <div style="text-align: center" :style="{border: notShowBorder ? '' : '1px solid black'}" v-on:click="getGroupAll(true)">{{org}}</div>
    <el-dialog
      width="550px"
      :visible="dialogVisible"
      :before-close="handleClose">
    <div style="width:50px;margin:5px;">{{company}}</div>
    <div style="display:flex;flex-wrap: wrap;width:500px">
      <el-button v-on:click="getGroup(1)" v-if="jituanVisible" style="width:70px;height:30px;margin:5px" :class="[org1 == 1 ? 'chosenButton' : '']">集团
      </el-button>
      <div v-for="(item, index) in orgGroup" >
        <el-button v-on:click="getGroup(item)" style="width:70px;height:30px;margin:5px" :class="[org1 == item.value ? 'chosenButton' : '']">{{item.label.replace('分公司','')}}
        </el-button>
      </div>
    </div>
    <div style="width:50px">{{company2}}</div>
    <div style="display:flex;flex-wrap: wrap;width:500px">
      <div v-for="(i, k) in orgGroup2" >
        <el-button v-on:click="getGroup2(i)" style="width:70px;height:30px;margin:5px" :class="[org2 == i.value ? 'chosenButton' : '']">{{getLabel(i.label)}}
        </el-button>
      </div>
    </div>
    <div style="width:50px" v-if="notShowOrg != 1">{{company3}}</div>
    <div style="display:flex;flex-wrap: wrap;width:500px" v-if="notShowOrg != 1">
      <div v-for="(i, k) in orgGroup3" >
        <el-button v-on:click="getGroup3(i)" style="width:150px;height:30px;margin:5px" :class="[org3 == i.value ? 'chosenButton' : '']">{{i.label.replace("设计","")}}
        </el-button>
      </div>
    </div>
      <span slot="footer">
        <el-button size="small" @click="handleClose">关闭</el-button>
        <el-button type="primary" size="small" @click="saveData">确定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
    export default {
      name: "index",
      props:['notShowOrg','notShowBorder'],
      data() {
        return {
          dialogVisible:false,
          jituanVisible:false,
          classZX:'',
          orgGroup:[],
          orgGroup3:[],
          orgGroup2:[],
          company2:'',
          company3:'',
          company:'',
          orgId1:'',
          orgId2:'',
          orgId3:'',
          org1:'',
          org2:'',
          org3:'',
          org:'',
        }
      },
      methods:{
        saveData(){
          this.$emit('getOrgId',this.orgId1,this.orgId2,this.orgId3);
          this.dialogVisible=false;
        },
        getGroupAll(flag){
          this.dialogVisible=flag;
          this.orgGroup=[];
          this.orgGroup2=[];
          this.orgGroup3=[];
          this.org1='';
          this.org2='';
          this.org3='';
          this.company2='';
          this.company3='';
          this.company='公司'
          this.$fetchData(this.$api.orgList.getCompanyForApp,{},'get').then(res=>{
            this.orgGroup=res;
            if(this.$store.getters.userInfo.orgId=='1'){
              this.org = '集团'
              this.jituanVisible=true;
            }else{
              console.log(this.orgGroup,"this.orgGroup")
              // this.org = this.orgGroup[0].label.substring(0,2)
              this.org = this.orgGroup[0].label.replace('分公司','')
              this.jituanVisible=false;
            }
          })
        },
        getGroup(item){
          this.orgGroup2=[];
          this.orgGroup3=[];
          this.company2='';
          this.company3='';
          this.orgId1='';
          this.orgId2='';
          this.orgId3='';
          if(item==1){
            this.org='集团'
            this.org1 = item
            this.org2 = ''
            this.org3 = ''
            return;
          }else if(item.id!='102114'&&item.id!='102243'){
            this.company3='中心'
            this.orgGroup3=item.children
            this.org=this.getLabel(item.label)
          }else{
            this.company2='分公司'
            this.org=this.getLabel(item.label)
            this.orgGroup2 = item.children
          }
          this.orgId1=item
          this.org1 = item.value
          this.org2 = ''
          this.org3 = ''
        },
        getGroup2(i){
          this.orgId3='';
          this.org=this.getLabel(i.label)
          this.company3='中心'
          this.orgId2=i
          this.orgGroup3 = i.children
          this.org2 = i.value
          this.org3 = ''
        },
        getGroup3(i){
          this.org=this.getLabel(i.label)
          this.orgId3=i
          this.org3 = i.value
        },
        getLabel(label){
          let label1 = label.replace("分公司","");
          return label1.replace("设计","");
        },
        // 关闭对话框
        handleClose() {
          this.orgId1='';
          this.orgId2='';
          this.orgId3='';
          this.org1='';
          this.org2='';
          this.org3='';
          this.getGroupAll(false);
          this.$emit('getOrgId','','','');
          this.dialogVisible=false;
        },
      },
      created(){
        this.getGroupAll(false)
      }
    }
</script>

<style lang="scss">
  #choseOrg{
    .chosenButton{
        background: bisque;
    }
  }
</style>
